module.exports = __webpack_public_path__ + "img/icon-company-events.eabd10b3.svg";